import { ref, onMounted } from "vue";
import { templateRef } from "@vueuse/core";
import { useScrollTriggerAnimation } from "/composables/useScrollTriggerAnimation";


export default {
  __name: 'index',
  props: {
  dataProvider: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const { unveilText, reveal } = useScrollTriggerAnimation();
const tpl_overlineWrapper = templateRef("tpl_overlineWrapper");
const tpl_overline = templateRef("tpl_overline");
const tpl_serieSubcategoryWrapper = templateRef("tpl_serieSubcategoryWrapper");
const tpl_serieSubcategory = templateRef("tpl_serieSubcategory");
const tpl_products = templateRef("tpl_products");
const tpl_buttonWrapper = templateRef("tpl_buttonWrapper");
const tpl_button = templateRef("tpl_button");
const tpl_carousel = templateRef("tpl_carousel");
const tpl_prevNext = templateRef("tpl_prevNext");
const swiper = ref(null);
const showNavigation = ref(false);

function checkNavigationNeeded() {
  if (!swiper.value) return;

  const totalSlides = props.dataProvider.items.length;
  const visibleSlides = Math.floor(swiper.value.params.slidesPerView);

  showNavigation.value = totalSlides > visibleSlides;
}

onMounted(() => {
  requestAnimationFrame(() => {
    const swiperEl = tpl_carousel.value;

    // Configure Swiper Element parameters
    const swiperParams = {
      slidesPerView: 1.5,
      speed: 650,
      loop: false,
      grabCursor: true,
      threshold: 10,
      spaceBetween: 24,

      slidesOffsetBefore: 24,
      slidesOffsetAfter: 24,
      roundLengths: true,
      freeMode: {
        enabled: true,
      },
      breakpoints: {
        600: {
          slidesPerView: 2.5,
          spaceBetween: 16,
          slidesOffsetBefore: 32,
          slidesOffsetAfter: 32,
        },
        1024: {
          slidesPerView: 3.5,
          spaceBetween: 24,
          slidesOffsetBefore: 40,
          slidesOffsetAfter: 40,
        },
        1280: {
          slidesPerView: 3.5,
          freeMode: false,
          spaceBetween: 32,
          slidesOffsetBefore: 56,
          slidesOffsetAfter: 56,
        },
        1536: {
          slidesPerView: 5,
          freeMode: false,
          spaceBetween: 40,
          slidesOffsetBefore: 72,
          slidesOffsetAfter: 72,
        },
        1800: {
          slidesPerView: 5,
          freeMode: false,
          spaceBetween: 56,
          slidesOffsetBefore: 96,
          slidesOffsetAfter: 96,
        },
      },
      on: {
        init: checkNavigationNeeded,
        resize: checkNavigationNeeded,
      },
    };

    // Assign parameters to the element
    Object.assign(swiperEl, swiperParams);

    // Initialize Swiper Element
    swiperEl.initialize();

    // Store swiper instance for potential future use
    swiper.value = swiperEl.swiper;

    reveal(tpl_overline.value, tpl_overlineWrapper.value, "top", {
      intensity: "normal",
      fade: true,
      duration: "long",
    });

    unveilText(
      tpl_serieSubcategory.value,
      tpl_serieSubcategoryWrapper.value,
      "bottom",
      {
        textTarget: "words",
        intensity: "strong",
        stagger: "wide",
        duration: "normal",
      }
    );

    reveal(swiperEl, tpl_products.value, "bottom", {
      intensity: "strong",
      fade: true,
      duration: "normal",
    });

    if (props.dataProvider?.serie_slug) {
      reveal(tpl_button.value.$el, tpl_buttonWrapper.value, "scale-up", {
        intensity: "weak",
        fade: true,
        duration: "long",
      });
    }

    if (props.dataProvider?.items?.length > 1) {
      if (showNavigation.value) {
        reveal(tpl_prevNext.value, tpl_buttonWrapper.value, "left", {
          intensity: "strong",
          fade: true,
          duration: "normal",
        });
      }
    }
  });
});

function handlePrevNext(goto) {
  goto === "next" ? swiper.value.slideNext() : swiper.value.slidePrev();
}

return { __sfc: true,props, unveilText, reveal, tpl_overlineWrapper, tpl_overline, tpl_serieSubcategoryWrapper, tpl_serieSubcategory, tpl_products, tpl_buttonWrapper, tpl_button, tpl_carousel, tpl_prevNext, swiper, showNavigation, checkNavigationNeeded, handlePrevNext }
}

}